import { useState, useMemo } from "react";
import { useRefinementList } from "react-instantsearch";
import { useDebouncedEffect } from "@grandvisionhq/utils";
import { filterFacetOption } from "../../../utils/Algolia/utils/filter-facet-option.js";
import { orderFacetOptions } from "../../../utils/Algolia/utils/order-facet-options.js";
const REFINEMENT_LIST_LIMIT = 100;
const useSearchableRefinementList = ({ facet }) => {
  const { items, refine, searchForItems, isFromSearch } = useRefinementList({
    attribute: facet.attribute,
    limit: REFINEMENT_LIST_LIMIT
  });
  const [query, setQuery] = useState("");
  useDebouncedEffect(() => searchForItems(query), 200, [query]);
  const sortedItems = useMemo(
    () => orderFacetOptions({ facet, items }).filter((item) => filterFacetOption(item, facet)),
    [facet, items]
  );
  return { sortedItems, refine, isFromSearch, setQuery };
};
export {
  useSearchableRefinementList
};
//# sourceMappingURL=use-searchable-refinement-list.js.map
